const sectionFaqCardCss = `
[data-type='section-faq-card'] .faq-grid-container-fluid {
  padding: 40px 0;
  width: 100%;
  margin: 0 auto;
  background-color: var(--background-container, #ffffff);
}

[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid:not(:empty) {
  margin-bottom: 32px;
}

[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h1,
[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h2,
[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h3 {
  font-size: 28px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h1:last-child,
[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h2:last-child,
[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-card'] .faq-grid-container-fluid[data-container-full-width='true'] .item-wapper {
  width: 100%;
}

[data-type='section-faq-card'] .faq-grid-container-fluid[data-container-full-width='false'] .item-wapper {
  width: 400px;
  margin: 0 auto;
}

[data-type='section-faq-card'] .faq-grid-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

[data-type='section-faq-card'] .faq-grid-content[data-layout='right'] .card-info {
  order: 2;
}

[data-type='section-faq-card'] .faq-grid-content[data-layout='right'] .list-item {
  order: 1;
}

[data-type='section-faq-card'] .card-info {
  height: 100%;
}

[data-type='section-faq-card'] .card-info .card-info-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  background-color: var(--background-card, #f7f8f9);
  border-radius: 8px;
  overflow: hidden;
  padding: 24px;
}

[data-type='section-faq-card'] .card-info .card-info-image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

[data-type='section-faq-card'] .card-info .card-info-image img {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

[data-type='section-faq-card'] .card-info .card-info-text h1,
[data-type='section-faq-card'] .card-info .card-info-text h2,
[data-type='section-faq-card'] .card-info .card-info-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-faq-card'] .card-info .card-info-text h1:last-child,
[data-type='section-faq-card'] .card-info .card-info-text h2:last-child,
[data-type='section-faq-card'] .card-info .card-info-text h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-card'] .card-info .card-info-text p {
  margin: 0 0 8px 0 !important;
  line-height: normal;
  font-size: 16px;
}

[data-type='section-faq-card'] .card-info .card-info-text p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-card'] .card-info .card-info-text strong {
  font-size: 18px;
}

[data-type='section-faq-card'] .list-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--background-card, #f7f8f9);
  border-radius: 8px;
  padding: 16px 8px;
}

[data-type='section-faq-card'] .list-item .item-wapper {
  background-color: var(--background-faq-item, #f7f8f9);
  color: var(--text-faq-item-color, #000000);
  border-bottom: 1px solid var(--border-faq-item, #e5e7eb);
  overflow: hidden;
  height: fit-content;
}

[data-type='section-faq-card'] .list-item .item-wapper:last-child {
  border-bottom: none;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question .item-question-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question .item-question-image {
  width: 26px;
  height: 26px;
  overflow: hidden;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question .item-question-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question .title-item-question {
  width: calc(100% - 40px);
  font-size: 16px;
  margin: 0 !important;
  flex: 1;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question span {
  display: flex;
}

[data-type='section-faq-card'] .list-item .item-wapper .item-question span svg {
  width: 20px;
  height: 20px;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content {
  padding: 0 16px 16px 52px;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1,
[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2,
[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1:last-child,
[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2:last-child,
[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-faq-card'] .faq-grid-container-fluid {
    padding: 16px 0;
  }

  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid {
    width: 100%;
  }

  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid:not(:empty) {
    margin-bottom: 24px;
  }

  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h1,
  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h2,
  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid h3 {
    font-size: 20px;
  }

  [data-type='section-faq-card'] .faq-grid-container-fluid .title-faq-grid p {
    font-size: 14px;
  }

  [data-type='section-faq-card'] .faq-grid-container-fluid[data-container-full-width='false'] .item-wapper {
    width: 100%;
  }

  [data-type='section-faq-card'] .faq-grid-content {
    grid-template-columns: 1fr;
    gap: 0px;
  }

  [data-type='section-faq-card'] .faq-grid-content[data-layout='right'] .card-info {
    order: 1;
  }

  [data-type='section-faq-card'] .faq-grid-content[data-layout='right'] .list-item {
    order: 2;
  }

  [data-type='section-faq-card'] .card-info .card-info-inner {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  [data-type='section-faq-card'] .list-item {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  [data-type='section-faq-card'] .list-item .item-wapper {
    width: 100%;
  }

  [data-type='section-faq-card'] .card-info .card-info-text h1,
  [data-type='section-faq-card'] .card-info .card-info-text h2,
  [data-type='section-faq-card'] .card-info .card-info-text h3 {
    font-size: 20px;
  }

  [data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1,
  [data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2,
  [data-type='section-faq-card'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3 {
    font-size: 20px;
    line-height: 24px;
  }
}
`;
export default sectionFaqCardCss;
